"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMessage = void 0;
const audi_i18n_context_1 = require("@volkswagen-onehub/audi-i18n-context");
const oneaudi_os_utils_1 = require("@volkswagen-onehub/oneaudi-os-utils");
const react_1 = require("react");
const useMessage = (localId, i18nScope = "oADD", rehydratedI18nStore = "oadd-i18n-hydration-store") => {
    var _a;
    const rehydratedI18nData = (0, react_1.useRef)((0, oneaudi_os_utils_1.rehydrateValue)(rehydratedI18nStore));
    const key = `${i18nScope}.${localId}`;
    const defaultMessage = (_a = rehydratedI18nData.current) === null || _a === void 0 ? void 0 : _a[key];
    return (0, audi_i18n_context_1.useI18n)({
        defaultMessage: defaultMessage || `__${key}__`,
        id: key,
    });
};
exports.useMessage = useMessage;
//# sourceMappingURL=messages.js.map